<template>
  <div class="headTop">
    <div class="container">
      <el-row>
        <!--LOGO-->
        <el-col :xs="24" :sm="6" :md="4" :lg="4" :xl="4">
          <div class="navbar-brand">
            <img src="@/assets/images/logo.png" class="logo">
          </div>
        </el-col>
        <!--  导航   Start-->
        <el-col :xs="24" :sm="14" :md="16" :lg="16" :xl="16">
          <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" router>
            <el-menu-item v-show="$store.state.pwoerMenuIds && $store.state.pwoerMenuIds.channelIds && $store.state.pwoerMenuIds.channelIds.indexOf(item.id) != -1
              " v-for="item in channelList" :key="item.id" :index="item.url" :indexPath="item.url"
              :class="{ 'item-select': defaultActive == item.url }" :style="{
                'height': '65px',
                color: '#000',
                'min-width': '100px',
                'text-align': 'center',
              }">{{ item.name }}</el-menu-item>
          </el-menu>
        </el-col>
        <!--  导航   End-->
        <el-col :xs="24" :sm="4" :md="4" :lg="4" :xl="4">
          <div class="grid-content"
            style="height: 65px;line-height: 60px; text-align: right;font-size: 14px;font-weight: 700;">
            <a class="register" @click="loginIn(1)" v-if="!user">登录</a>
            <span v-if="!user">&nbsp;|&nbsp;</span>
            <a class="register" @click="loginIn(2)" v-if="!user">注册</a>
            <el-dropdown v-else style="height: 50px; width: 100%" @command="logout">
              <el-row>
                <el-col :span="4" :offset="4">
                  <img src="../assets/banner/header.png" style="vertical-align: middle" />
                </el-col>
                <el-col :span="12" style="
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #1ab2ff;
                  ">
                  <a class="register">{{
                    user.nickName == null || user.nickName == ""
                      ? user.userName
                      : user.nickName
                  }}</a>
                </el-col>
                <el-col :span="4">
                  <img src="../assets/banner/triangular.png" style="vertical-align: middle" />
                </el-col>
              </el-row>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">个人中心</el-dropdown-item>
                <el-dropdown-item command="2">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>
      <login></login>
    </div>
    <el-dialog title="个人信息" :visible.sync="showMyInfo" width="70%" center append-to-body>
      <myInfo></myInfo>
    </el-dialog>
  </div>
</template>

<script>
import login from '../components/login'
// eslint-disable-next-line no-unused-vars
import {
  removeRefreshToken,
  removeRefreshTokenTime,
  removeTime,
  removeToken
} from '../utils/auth'
import { getFrontMenuMap, visitorQuery } from '../api/register'
import myInfo from '@/views/my/components/myInfo.vue'
export default {
  components: { login, myInfo },
  data () {
    return {
      channelList: [],
      user: this.$store.state.user,
      showMyInfo: false
    }
  },
  created () {
    this.getMenu(this.siteId)
    this.handleMenuList()
  },
  watch: {
    '$store.state.user': function (newFlag, oldFlag) {
      this.user = this.$store.state.user
    }
  },
  computed: {
    defaultActive: function (e) {
      return this.$route.path
    }
  },

  methods: {
    getMenu (siteId) {
      if (this.$store.state.user) {
        getFrontMenuMap(this.authURL).then((res) => {
          if (res.frontMenuMap.channelIds.length === 0) {
            this.getVisitorQuery()
          } else {
            this.$store.commit('setPwoerMenuIds', res.frontMenuMap)
          }
        })
      } else {
        this.getVisitorQuery(siteId)
      }
    },
    getVisitorQuery (siteId) {
      let url = this.siteURL + '/actuator/channel/list/' + siteId
      visitorQuery(url).then((res) => {
        this.$store.commit('setPwoerMenuIds', res.data)
      })
    },
    handleMenuList () {
      var api = this.siteURL + '/actuator/channel/list?parentId=-1&showNav=0&siteId=' + this.siteId
      this.axios.get(api, {}).then((response) => {
        this.channelList = response.data.rows
      })
    },
    loginIn (index) {
      // eslint-disable-next-line eqeqeq
      if (index == 1) {
        this.$store.commit('loginVisibleMutations', true)
        // eslint-disable-next-line eqeqeq
      } else if (index == 2) {
        this.$store.commit('registerFormVisibleMutations', true)
      }
    },
    logout (e) {
      console.log(e)
      if (e == 1) {
        this.showMyInfo = true
        // this.$router.push({
        //   name: 'myInfo'
        // })
      } else {
        this.user = undefined
        this.$router.push('/')
        this.$store.commit('logout')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navigation .el-menu-item {
  font-size: 17px;
  height: 75px !important;
}

.navigation .el-menu.el-menu--horizontal {
  border-bottom: solid 0px #e6e6e6;
}

.register {
  color: #0c70fc;
  cursor: pointer;
  text-align: right;
  text-align: left;
  padding: 0 5px;
  font-size: 14px;
}

.register:hover {
  color: #0c70fc;
}

.headTop .el-row {
  margin: 0;
}
</style>
<style>
.headTop .el-menu.el-menu--horizontal {
  border: none;
}

.item-select {
  background-image: url("~@/assets/images/header-item-bg.png");
  color: #00A1BB !important;
}
</style>

<style scoped>
/deep/ .el-menu-item.is-active:before,
/deep/ .el-menu-item.is-active:after {
  content: none !important; /* 移除伪元素的内容 */
}

/deep/ .el-menu-item.is-active {
  border-bottom: none !important; /* 直接移除下边框 */
}

.logo {
  width: 100%;
  height: 55px;
  padding: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/HeadTop.vue